module.exports = __webpack_public_path__ + "img/map_panda_head.3f751861.png";